import { c as _c } from "react/compiler-runtime";
import ControlledRadioCardGroup from "@components/hookform/RadioCardGroup";
import { Control } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";
export interface SelectFieldProps<T extends FieldValues> {
  control: Control<T>;
  fieldDefinition: FormFieldDefinition<T>;
}
const RadioCardField = t0 => {
  const $ = _c(9);
  const {
    control,
    fieldDefinition
  } = t0;
  let t1;
  if ($[0] !== fieldDefinition.options) {
    t1 = fieldDefinition.options || [];
    $[0] = fieldDefinition.options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = fieldDefinition.label || "";
  let t3;
  if ($[2] !== control || $[3] !== fieldDefinition.defaultValue || $[4] !== fieldDefinition.name || $[5] !== fieldDefinition.rules || $[6] !== t1 || $[7] !== t2) {
    t3 = <div className="max-w-[360px]"><ControlledRadioCardGroup control={control} name={fieldDefinition.name} rules={fieldDefinition.rules} options={t1} label={t2} defaultValue={fieldDefinition.defaultValue} /></div>;
    $[2] = control;
    $[3] = fieldDefinition.defaultValue;
    $[4] = fieldDefinition.name;
    $[5] = fieldDefinition.rules;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default RadioCardField;